export default function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
  //var domain = process.env.SITE_NAME;
  document.cookie =
    key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
}
